import { toZonedTime } from 'date-fns-tz';

export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const toUtcDayStart = (date) =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));

export const toUtcDayEnd = (date) =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999));

export const getDateRangeByType = (rangeType, timezone) => {
  const tz = timezone || getTimezone();
  const zonedNow = toZonedTime(new Date(), tz);
  const year = zonedNow.getFullYear();
  const month = zonedNow.getMonth();
  const day = zonedNow.getDate();
  const today = new Date(year, month, day);

  let start = today;
  let end = today;

  switch (rangeType) {
    case 'lastMonth':
      start = new Date(year, month - 1, 1);
      end = new Date(year, month, 0);
      break;
    case 'last7Days':
      start = new Date(year, month, day - 6);
      end = today;
      break;
    case 'last30Days':
      start = new Date(year, month, day - 29);
      end = today;
      break;
    case 'thisWeek': {
      // Monday-based week (matches picker's weekStartsOn=1)
      const dayOfWeek = today.getDay() || 7; // Sunday=0 → 7
      start = new Date(year, month, day - (dayOfWeek - 1));
      end = new Date(year, month, day - (dayOfWeek - 1) + 6);
      break;
    }
    case 'thisMonth':
      start = new Date(year, month, 1);
      end = new Date(year, month + 1, 0);
      break;
    case 'yesterday': {
      const yesterday = new Date(year, month, day - 1);
      start = yesterday;
      end = yesterday;
      break;
    }
    case 'today':
      break;
    default:
      break;
  }

  return {
    start: toUtcDayStart(start).toISOString(),
    end: toUtcDayEnd(end).toISOString(),
  };
};

/**
 * The window of the same length immediately before [start, end], for
 * period-over-period comparison. Both bounds are inclusive whole days, so a
 * 7-day range compares against the 7 days before it.
 */
export const getPreviousPeriod = (startIso, endIso) => {
  const start = new Date(startIso);
  const end = new Date(endIso);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;

  const DAY = 86400000;
  // end is a day-end (23:59:59.999), so round up to whole days.
  const days = Math.max(1, Math.round((end.getTime() - start.getTime()) / DAY));
  const prevEnd = new Date(start.getTime() - 1);
  const prevStart = new Date(start.getTime() - days * DAY);

  return { start: prevStart.toISOString(), end: prevEnd.toISOString() };
};
